import React, { Component } from "react";

const HireLawyer = () => {
  return <h1>Hire A Lawyer</h1>;
};

export default HireLawyer;
